<template>
<Form :label-width="80" class="mt15 w1000">
    <FormItem 
    	label="投保单：">
    	<div class="desc">
    		请先下载投保单，盖上公司公章后再回传投保单。<span v-if="multiple" style="color:red">（一张投保单和一张人员清单，两张都要签字盖章上传）</span>
    		<a :href="`/pc/employerLiability/exportInsurancePolicy?id=${info.count||info.id}`" target="_blank">下载投保单</a>
    	</div>
    	<Form class="policy" :model="form" ref="form" :label-width="0">
    		<Form-item 
    			class="policy-item" 
    			v-for="(p,i) in form.insurancePolicyUrl"
    			:prop="'insurancePolicyUrl.' + i + '.insurancePolicyUrl'"
    			:key="i"
    			:rules="{required:true,message:'请上传投保单',trigger:'change'}">
    			<UploadImg 
    				v-model="p.insurancePolicyUrl" 
    				@on-remove="removeImg(i)"
    				:show-del="form.insurancePolicyUrl.length>1" />
    			<Input v-model="p.insurancePolicyUrl" v-show="false"></Input>
    		</Form-item>
    		<div class="policy-item" v-if="multiple&&form.insurancePolicyUrl.length<10">
    			<a @click="add">添加投保单</a>
    		</div>
    	</Form>
    </FormItem>
</Form>
</template>
<script>
import UploadImg from '../common/UploadImg'
export default {
	components:{ UploadImg },
	props:{ 
		info:Object,
		multiple:Boolean
	},
	data () {
		return{
			form:{
				insurancePolicyUrl:this.info.insurancePolicyUrl||[{
					insurancePolicyUrl:''
				}]
			}
		}
	},
	methods:{
		async val () {
			let flag = await this.$refs.form.validate();
			if(!flag)return;
			return new Promise((resolve,reject)=>{
				resolve(this.form)
			})
		},
		add () {
			this.form.insurancePolicyUrl.push({
				insurancePolicyUrl:''
			})
		},
		removeImg (i) {
			this.form.insurancePolicyUrl.splice(i,1);
		}
	},
	// watch:{
	// 	'info.insurancePolicyUrl' (v) {
	// 		console.log(v)
	// 		this.form.insurancePolicyUrl = v;
	// 	}
	// }
}
</script>
<style scoped>
	.policy{
		display:flex;
	}
	.policy-item{
		margin-right: 15px;
	}
</style>


// WEBPACK FOOTER //
// src/pages/haierProduct/components/common/InsuranceSlip.vue